import { navigationMutations } from './navigationMutations';
import { userMutations } from './userMutations';

export const mutations = {
	...navigationMutations,
	...userMutations,
};

export { validateCurrentStepFormFields } from './validateCurrentStepFormFields';
